/**
 * Jawliner – Variant Image Filter (override)
 *
 * Fixes the broken alt-tag image filtering in the Focal/Maestrooo theme.
 *
 * Alt tag format on images in Shopify:
 *   Single option:  #OptionName_OptionValue
 *   Multi option:   #OptionName_OptionValue #OptionName2_OptionValue2
 *   Shared image:   (no # in alt — always visible)
 *
 * Example:
 *   "#Choose your Flavour_Kiwi Passion Fruit"
 *   "#Choose your Flavour_Kiwi Passion Fruit #Choose your Package_6 Months Supply - BESTSELLER"
 *
 * NOTE: When an alt tag contains " - BESTSELLER" or similar suffix after the value,
 *       the script strips everything after " - " so it still matches correctly.
 *       Adjust SUFFIX_SEPARATOR below if your suffix uses a different delimiter.
 */

(function () {
  'use strict';

  var SUFFIX_SEPARATOR = ' - ';

  /**
   * Parse all #-tagged groups from an alt string.
   * Returns an array of { optionName, optionValue } objects.
   * Returns empty array if no # tags present (image is shared/always visible).
   */
  function parseAltGroups(alt) {
    if (!alt || !alt.includes('#')) return [];

    var groups = [];
    var parts = alt.split('#');

    for (var i = 1; i < parts.length; i++) {
      var segment = parts[i].trim();
      if (!segment) continue;

      var underscoreIndex = segment.indexOf('_');
      if (underscoreIndex === -1) continue;

      var optionName = segment.substring(0, underscoreIndex).trim().toLowerCase();
      var rawValue = segment.substring(underscoreIndex + 1).trim();

      if (rawValue.indexOf(SUFFIX_SEPARATOR) !== -1) {
        rawValue = rawValue.substring(0, rawValue.indexOf(SUFFIX_SEPARATOR)).trim();
      }

      var optionValue = rawValue.toLowerCase();

      if (optionName && optionValue) {
        groups.push({ optionName: optionName, optionValue: optionValue });
      }
    }

    return groups;
  }

  /**
   * Determine which media IDs should be hidden for the given variant.
   * A media item is hidden when ANY of its alt groups doesn't match the
   * selected variant option.
   */
  function getFilteredIds(productData, variant) {
    var filteredIds = [];
    var featuredMediaId = variant.featured_media ? variant.featured_media.id : null;

    productData.media.forEach(function (media) {
      if (media.id === featuredMediaId) return;

      var groups = parseAltGroups(media.alt);
      if (groups.length === 0) return;

      var shouldFilter = false;

      for (var i = 0; i < groups.length; i++) {
        var group = groups[i];

        var matchedOption = productData.options.find(function (opt) {
          return opt.name.toLowerCase() === group.optionName;
        });

        if (!matchedOption) continue;

        var selectedValue = variant.options[matchedOption.position - 1];
        if (!selectedValue) continue;

        if (selectedValue.toLowerCase() !== group.optionValue) {
          shouldFilter = true;
          break;
        }
      }

      if (shouldFilter) {
        filteredIds.push(media.id);
      }
    });

    return filteredIds;
  }

  /**
   * Apply filtered/selected classes to all [data-media-id] elements inside
   * a product-media component, then reload Flickity.
   */
  function applyFilter(productMediaEl, productData, variant) {
    var filteredIds = getFilteredIds(productData, variant);

    var featuredMediaId = variant.featured_media ? variant.featured_media.id : null;

    var selectedMediaId = featuredMediaId;
    if (!selectedMediaId) {
      var firstVisible = productData.media.find(function (m) {
        return !filteredIds.includes(m.id);
      });
      if (firstVisible) selectedMediaId = firstVisible.id;
    }

    var allItems = Array.from(productMediaEl.querySelectorAll('[data-media-id]'));
    var filterChanged = false;

    allItems.forEach(function (item) {
      var mediaId = parseInt(item.getAttribute('data-media-id'), 10);
      var isFiltered = filteredIds.includes(mediaId);
      var isSelected = mediaId === selectedMediaId;

      if (item.classList.contains('is-filtered') !== isFiltered) {
        filterChanged = true;
      }

      item.classList.toggle('is-filtered', isFiltered);
      item.classList.toggle('is-selected', isSelected);
      item.classList.toggle('is-initial-selected', isSelected);
    });

    var carousel = productMediaEl.mainCarousel || productMediaEl.querySelector('flickity-carousel');
    if (!carousel) return;

    if (filterChanged && typeof carousel.reload === 'function') {
      carousel.reload();
    } else if (selectedMediaId && typeof carousel.select === 'function') {
      carousel.select('[data-media-id="' + selectedMediaId + '"]');
    }
  }

  /**
   * Patch a single product-media element.
   * Waits for the element's `product` property to be populated by the theme.
   */
  function patchProductMedia(el) {
    var formId = el.getAttribute('form-id');
    if (!formId) return false;

    var form = document.getElementById(formId);
    if (!form) return false;

    function onVariantChange(event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;

      var productData = el.product;
      if (!productData || !productData.media) return;

      applyFilter(el, productData, variant);
    }

    form.addEventListener('variant:changed', onVariantChange);
    return true;
  }

  /**
   * Wait for product-media custom elements to be defined and connected,
   * then patch their variant change handlers.
   */
  function init() {
    var productMediaEls = document.querySelectorAll('product-media');

    productMediaEls.forEach(function (el) {
      if (el._variantFilterPatched) return;
      el._variantFilterPatched = patchProductMedia(el);
    });

    if (productMediaEls.length === 0) {
      var observer = new MutationObserver(function (mutations, obs) {
        var els = document.querySelectorAll('product-media');
        if (els.length > 0) {
          obs.disconnect();
          els.forEach(function (el) {
            if (el._variantFilterPatched) return;
            el._variantFilterPatched = patchProductMedia(el);
          });
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
